/* Official Shopify bundle compatibility cache-bust 2026-08-10. */
(function(){
  'use strict';

  /*
   * Peekora auto-gift dismissal guard.
   *
   * The original offer engine is preserved in pk-offer-eligibility-core.js.
   * This guard sits underneath it and remembers when a shopper intentionally
   * removes the automatically added MiniScope. The gift remains automatic for
   * newly eligible carts, but it is not forced back into the same eligible cart
   * after dismissal. Dropping below the eligibility threshold resets the choice.
   */
  var loader=document.currentScript;
  var loaderSrc=loader&&loader.src||'';
  var coreSrc=(loader&&loader.getAttribute('data-core-src'))||loaderSrc.replace(/pk-offer-eligibility\.js(?=\?|$)/,'pk-offer-eligibility-core.js');
  var nativeFetch=window.fetch.bind(window);
  var MINI_VARIANT_ID=46223639216207;
  var SD_HANDLE='32-gb-sd-card';
  var GIFT_THRESHOLD=2;
  var STORAGE_PREFIX='pk_auto_gift_dismissed:';
  var latestToken='';
  var latestCart=null;
  var previousState={};

  function lower(value){return String(value==null?'':value).toLowerCase();}
  function handle(item){return lower(item&&item.product_handle||item&&item.handle);}
  function props(item){return item&&item.properties||{};}
  function isMini(item){return Number(item&&item.variant_id||0)===MINI_VARIANT_ID||lower(item&&item.product_title).indexOf('miniscope')!==-1;}
  function isSd(item){var title=lower(item&&item.product_title);return handle(item)===SD_HANDLE||title.indexOf('micro sd')!==-1||title.indexOf('sd card')!==-1;}
  function isScope(item){return !isMini(item)&&!isSd(item)&&(handle(item)==='peekorascope-explorer-kids-microscope'||lower(item&&item.product_title).indexOf('peekorascope')!==-1);}
  function isAutoGift(item){
    var p=props(item);
    return isMini(item)&&(String(p._peekora_auto_gift||'')==='true'||Boolean(p._free_gift)||String(p._peekora_bundle_gift||'')==='true');
  }
  function cartToken(cart){return String(cart&&cart.token||'').split('?')[0]||'session';}
  function storageKey(token){return STORAGE_PREFIX+(token||'session');}
  function dismissed(token){
    try{return sessionStorage.getItem(storageKey(token))==='1';}
    catch(error){return false;}
  }
  function setDismissed(token,value){
    try{
      if(value)sessionStorage.setItem(storageKey(token),'1');
      else sessionStorage.removeItem(storageKey(token));
    }catch(error){}
  }
  function inspectCart(cart){
    if(!cart||!Array.isArray(cart.items))return;
    var token=cartToken(cart);
    var qty=cart.items.reduce(function(total,item){return total+(isScope(item)?Number(item.quantity||0):0);},0);
    var hasMini=cart.items.some(isMini);
    var hasAutoGift=cart.items.some(isAutoGift);
    var prior=previousState[token];

    latestToken=token;
    latestCart=cart;

    if(qty<GIFT_THRESHOLD){
      setDismissed(token,false);
    }else if(prior&&prior.hasAutoGift&&!hasAutoGift&&!hasMini){
      setDismissed(token,true);
    }

    previousState[token]={qty:qty,hasMini:hasMini,hasAutoGift:hasAutoGift};
  }
  function requestUrl(input){if(typeof input==='string')return input;if(input&&input.url)return input.url;return '';}
  function requestBody(init){
    if(!init||typeof init.body!=='string')return null;
    try{return JSON.parse(init.body);}catch(error){return null;}
  }
  function isAutoGiftAdd(input,init){
    var url=requestUrl(input);
    if(url.indexOf('/cart/add')===-1)return false;
    var body=requestBody(init);
    var items=body&&Array.isArray(body.items)?body.items:[];
    return items.some(function(item){
      var p=item&&item.properties||{};
      return Number(item&&item.id||0)===MINI_VARIANT_ID&&String(p._peekora_auto_gift||'')==='true';
    });
  }
  function fakeSuccess(){
    var payload=latestCart||{items:[],item_count:0};
    return new Response(JSON.stringify(payload),{status:200,headers:{'Content-Type':'application/json'}});
  }

  window.fetch=function(input,init){
    if(isAutoGiftAdd(input,init)&&latestToken&&dismissed(latestToken)){
      return Promise.resolve(fakeSuccess());
    }

    return nativeFetch(input,init).then(function(response){
      var url=requestUrl(input);
      if(url.indexOf('/cart.js')!==-1){
        try{response.clone().json().then(inspectCart).catch(function(){});}catch(error){}
      }
      return response;
    });
  };

  if(coreSrc&&coreSrc!==loaderSrc){
    var core=document.createElement('script');
    core.src=coreSrc;
    core.async=false;
    if(loader&&loader.nonce)core.nonce=loader.nonce;
    core.onerror=function(){console.error('[Peekora] Offer eligibility core failed to load.');};
    (document.head||document.documentElement).appendChild(core);
  }else{
    console.error('[Peekora] Unable to resolve offer eligibility core asset.');
  }
})();

